import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RxChangeAlertsDetails {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  RxChangeAlertsDetailsData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: RxChangeAlertsDetails = {
  isLoading: false,
  error: false,
  message: null,
  RxChangeAlertsDetailsData: [],
  Items: [],
  Pagination: [],
};

const RxChangeAlertsDetailsSlice = createSlice({
  name: "RxChangeAlertsDetails",
  initialState,
  reducers: {
    loadingRxChangeAlertsDetails: (
      state: RxChangeAlertsDetails,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setRxChangeAlertsDetails: (
      state: any,
      action: PayloadAction<RxChangeAlertsDetails>
    ) => {
      return action.payload;
    },
    clearData: (state: RxChangeAlertsDetails, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const {
  loadingRxChangeAlertsDetails,
  setRxChangeAlertsDetails,
  clearData,
} = RxChangeAlertsDetailsSlice.actions;
export default RxChangeAlertsDetailsSlice.reducer;
